import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { END_POINT } from './apiConfig';
import enTranslation from '../locales/en/translation.json';
import viTranslation from '../locales/vi/translation.json';

// Define the supported languages


// Import language resources


// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      vi: {
        translation: viTranslation,
      },
    },
    fallbackLng: 'vi',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

// Function to update API language
export const updateApiLanguage = (language: string) => {
  const ENV_ENVIRONMENT = 'staging' as keyof typeof END_POINT;
  const baseUrl = END_POINT[ENV_ENVIRONMENT].BASE_URL;
  
  // Update API base URL with language
  return `${baseUrl}/${language}/api/v1`;
};

export default i18n;
